import { NavLink } from 'react-router-dom'

import styles from './NavBar2.module.css'

const menus = [
    {
      icon: "🖥️",
      title: "Digitalització els seguiments de les persones",
      description: "Transforma els teus registres en format digitals i realitza els seguiments de manera més eficient.",
      image: "path/to/image1.jpg",
      to: "/digitalitza"
    },
    {
      icon: "🔤",
      title: "Transcripció automàtica dels seguiments fets amb veu.",
      description: "Realitza els seguiments en format audio i transcriu-los de manera automàtica, integrant-se al moment en el sistema.",
      image: "path/to/image2.jpg",
      to: "/transcripcio"
    },
    {
      icon: "📢",
      title: "Millora la comunicació entre les persones de l'organització.",
      description: "Els diferents canals permeten augmentar la comunicació entre els diferents interessats.",
      image: "path/to/image2.jpg",
      to: "/features"
      // to: "/comunicacio"
    },
    {
      icon: "🗓️",
      title: "Planifica i controla el compliment dels seguiments.",
      description: "Realitza un control dels seguiments, ja sigui en unitats realitzades o en temps de dedicació.",
      image: "path/to/image2.jpg",
      to: "/features"
      // to: "/planificacio"
    },
    {
      icon: "📊",
      title: "Altres funcionalitats rellevants a explorar",
      description: "Descobreix altres funcionalitats que permeten la gestió de les persones ateses de la teva organització.",
      image: "path/to/image2.jpg",
      to: "/features"
      // to: "/altres-funcionalitats"
    },
]

const menus2 = [
  {
    icon: "🖥️",
    title: "Digitalización de los seguimientos de las personas",
    description: "Transforma tus registros en formato digital y realiza los seguimientos de manera más eficiente.",
    image: "path/to/image1.jpg",
    to: "/digitaliza"
  },
  {
    icon: "🔤",
    title: "Transcripción automática de los seguimientos hechos con voz.",
    description: "Realiza los seguimientos en formato audio y transcríbelos de manera automática, integrándose al momento en el sistema.",
    image: "path/to/image2.jpg",
    to: "/transcripcion"
  },
  {
    icon: "📢",
    title: "Mejora la comunicación entre las personas de la organización.",
    description: "Los diferentes canales permiten aumentar la comunicación entre los diferentes interesados.",
    image: "path/to/image2.jpg",
    to: "/features"
    // to: "/comunicacion"
  },
  {
    icon: "🗓️",
    title: "Planifica y controla el cumplimiento de los seguimientos.",
    description: "Realiza un control de los seguimientos, ya sea en unidades realizadas o en tiempo de dedicación.",
    image: "path/to/image2.jpg",
    to: "/features"
    // to: "/planificacion"
  },
  {
    icon: "📊",
    title: "Otras funcionalidades relevantes a explorar",
    description: "Descubre otras funcionalidades que permiten la gestión de las personas atendidas de tu organización.",
    image: "path/to/image2.jpg",
    to: "/features"
    // to: "/otras-funcionalidades"
  },
]

const menus3 = [
  {
    icon: "🖥️",
    title: "Digitization of people tracking",
    description: "Transform your records into digital format and track more efficiently.",
    image: "path/to/image1.jpg",
    to: "/digitize"
  },
  {
    icon: "🔤",
    title: "Automatic transcription of voice tracking.",
    description: "Perform tracking in audio format and transcribe it automatically, integrating it into the system instantly.",
    image: "path/to/image2.jpg",
    to: "/transcription"
  },
  {
    icon: "📢",
    title: "Improve communication among organization members.",
    description: "Different channels allow for increased communication among various stakeholders.",
    image: "path/to/image2.jpg",
    to: "/features"
    // to: "/communication"
  },
  {
    icon: "🗓️",
    title: "Plan and control the fulfillment of tracking.",
    description: "Control tracking, whether in units completed or time dedicated.",
    image: "path/to/image2.jpg",
    to: "/features"
    // to: "/planning"
  },
  {
    icon: "📊",
    title: "Other relevant features to explore",
    description: "Discover other features that allow the management of people attended by your organization.",
    image: "path/to/image2.jpg",
    to: "/features"
    // to: "/other-features"
  },
]

const NavBar2 = (props) => {

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <nav className={styles.navbar}>
        <ul className={styles.nav_links}>
            {
              menus.map((menu, index) => (
                  <li key={index} className={styles.nav_item}>
                      <NavLink to={menu.to} key={index} className={styles.item} onClick={() => {props.setOpen(!props.open); scrollToTop()}}>
                          <div className={styles.icon}>{menu.icon}</div>
                          <div className={styles.content}>
                              <h3 className={styles.featureTitle}>{menu.title}</h3>
                              <p className={styles.description}>{menu.description}</p>
                              <i className="fa-solid fa-arrow-right"></i>
                          </div>
                      </NavLink>
                  </li>
              ))
            }
            {/* {
              props.language === 'ca' && menus.map((menu, index) => (
                  <li key={index} className={styles.nav_item}>
                      <NavLink to={menu.to} key={index} className={styles.item} onClick={() => {props.setOpen(!props.open); scrollToTop()}}>
                          <div className={styles.icon}>{menu.icon}</div>
                          <div className={styles.content}>
                              <h3 className={styles.featureTitle}>{menu.title}</h3>
                              <p className={styles.description}>{menu.description}</p>
                              <i className="fa-solid fa-arrow-right"></i>
                          </div>
                      </NavLink>
                  </li>
              ))
            }
            {
              props.language === 'es-ES' && menus2.map((menu, index) => (
                  <li key={index} className={styles.nav_item}>
                      <NavLink to={menu.to} key={index} className={styles.item} onClick={() => {props.setOpen(!props.open); scrollToTop()}}>
                          <div className={styles.icon}>{menu.icon}</div>
                          <div className={styles.content}>
                              <h3 className={styles.featureTitle}>{menu.title}</h3>
                              <p className={styles.description}>{menu.description}</p>
                              <i className="fa-solid fa-arrow-right"></i>
                          </div>
                      </NavLink>
                  </li>
              ))
            }
            {
              props.language !== 'ca' && props.language !== 'es-ES' && menus3.map((menu, index) => (
                  <li key={index} className={styles.nav_item}>
                      <NavLink to={menu.to} key={index} className={styles.item} onClick={() => {props.setOpen(!props.open); scrollToTop()}}>
                          <div className={styles.icon}>{menu.icon}</div>
                          <div className={styles.content}>
                              <h3 className={styles.featureTitle}>{menu.title}</h3>
                              <p className={styles.description}>{menu.description}</p>
                              <i className="fa-solid fa-arrow-right"></i>
                          </div>
                      </NavLink>
                  </li>
              ))
            } */}
        </ul>
    </nav>
  )
}

export default NavBar2